import { Fragment, useEffect, useState } from "react";
import { Dialog, Popover, Tab, Transition } from "@headlessui/react";
import {
  Bars3Icon,
  ShoppingCartIcon,
  UserIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import baseURL from "../../utils/baseURL";
import logo from "../../assets/img/nutrad.png";
import clogo from "../../assets/img/customers/Synchcor.png";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategoriesAction } from "../../redux/slices/categories/categoriesSlice";
import { getCartItemsFromLocalStorageAction } from "../../redux/slices/cart/cartSlices";
import { logoutAction } from "../../redux/slices/users/usersSlice";
import axios from "axios";
import GLOBALS from "../../utils/Globals";
import { fetchCouponsAction } from "../../redux/slices/coupons/couponsSlice";
import NavDropdown from "react-bootstrap/NavDropdown";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Badge from "react-bootstrap/Badge";

export default function AppNavbar() {
  //dispatch
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchCategoriesAction());
  }, [dispatch]);
  //get data from store
  const { categories } = useSelector((state) => state?.categories);

  const categoriesToDisplay = categories?.categories?.slice(0, 3);

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [documentCount, setDocumentCount] = useState(0);
  //get data from store
  useEffect(() => {
    dispatch(getCartItemsFromLocalStorageAction());
  }, [dispatch]);
  const { cartItems } = useSelector((state) => state?.carts);
  //get cart items from local storage
  let cartItemsFromLocalStorage;
  //get login user from localstorage

  const user = JSON.parse(localStorage.getItem("userInfo"));

  const isLoggedIn = user?.token ? true : false;
  //logout handler
  const logoutHandler = () => {
    dispatch(logoutAction());
    //reload
    window.location.reload();
  };
  //coupons
  useEffect(() => {
    dispatch(fetchCouponsAction());
  }, [dispatch]);
  //get coupons
  const { coupons, loading, error } = useSelector((state) => state?.coupons);

  // Fetch document count for badge
  const fetchDocumentCount = async () => {
    try {
      console.log("=== NAVBAR: Fetching document count ===");
      const baseURLGetAllPDFDocs =
        process.env.REACT_APP_ENV === "PROD"
          ? GLOBALS.PROD.baseURLGetAllPDFDocs
          : GLOBALS.DEV.baseURLGetAllPDFDocs;

      console.log("API URL:", baseURLGetAllPDFDocs);
      const response = await axios.get(baseURLGetAllPDFDocs);
      console.log("API Response:", response.data);

      if (response.data && Array.isArray(response.data)) {
        console.log("Document count:", response.data.length);
        setDocumentCount(response.data.length);
      } else {
        console.log("No valid data array found");
        setDocumentCount(0);
      }
    } catch (error) {
      console.error("Error fetching document count:", error);
      setDocumentCount(0);
    }
  };

  // Fetch document count on component mount
  useEffect(() => {
    console.log("=== NAVBAR: useEffect triggered ===");
    console.log("isLoggedIn:", isLoggedIn);
    console.log("user:", user);
    if (isLoggedIn) {
      fetchDocumentCount();
    }
  }, [isLoggedIn]);

  return (
    <Navbar 
      expand="lg" 
      className="py-3 border-bottom shadow-sm sticky-top" 
      bg="white"
      variant="light"
    >
      <Container fluid>
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
          <img
            src={clogo}
            alt="nutrād logo"
            height="40"
            className="d-inline-block align-top me-2"
          />
        </Navbar.Brand>
        
        <Navbar.Toggle aria-controls="basic-navbar-nav" className="border-0">
          <Bars3Icon className="h-6 w-6" />
        </Navbar.Toggle>
        
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto me-auto">
            <NavDropdown
              title={
                <span className="nav-link-custom">
                  <i className="bi bi-upload me-1"></i>Import
                </span>
              }
              id="import-dropdown"
            >
              <NavDropdown.Item as={Link} to="/import">
                Import Product Data Files
              </NavDropdown.Item>
            </NavDropdown>

            <NavDropdown
              title={
                <span className="nav-link-custom">
                  <i className="bi bi-gear me-1"></i>Manage
                  {documentCount > 0 && (
                    <Badge
                      bg="primary"
                      className="ms-2"
                      style={{ fontSize: '0.75em' }}
                    >
                      {documentCount}
                    </Badge>
                  )}
                </span>
              }
              id="manage-dropdown"
            >
              <NavDropdown.Item as={Link} to="/products">
                Manage Products
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/s3">
                View Exported Product Data
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/schema/upload">
                Schema Upload
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/ai-field-logic">
                <i className="bi bi-cpu me-2"></i>AI Field Logic
              </NavDropdown.Item>
            </NavDropdown>

            <NavDropdown
              title={
                <span className="nav-link-custom">
                  <i className="bi bi-diagram-3 me-1"></i>SmartPipes
                </span>
              }
              id="smartpipes-dropdown"
            >
              <NavDropdown.Item as={Link} to="/connections">
                Connections
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/destinations">
                Destinations
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/validations">
                Validations
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/gdsn">
                GDSN Datapools
              </NavDropdown.Item>
            </NavDropdown>

            <NavDropdown
              title={
                <span className="nav-link-custom">
                  <i className="bi bi-tools me-1"></i>Tools
                </span>
              }
              id="tools-dropdown"
            >
              <NavDropdown.Item as={Link} to="/gtin_search">
                GTIN Search
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/gln_search">
                GLN Search
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/search-data-hub">
                Search Data Hub
              </NavDropdown.Item>
            </NavDropdown>

            <NavDropdown
              title={
                <span className="nav-link-custom">
                  <i className="bi bi-file-earmark-bar-graph me-1"></i>Reports
                </span>
              }
              id="reports-dropdown"
            >
              <NavDropdown.Item as={Link} to="/publishing-reports">
                Publishing Reports
              </NavDropdown.Item>
            </NavDropdown>

            <NavDropdown
              title={
                <span className="nav-link-custom">
                  <i className="bi bi-graph-up me-1"></i>Analytics
                </span>
              }
              id="analytics-dropdown"
            >
              <NavDropdown.Item as={Link} to="/analytics/dashboard">
                Product Analytics
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/analytics/publishing">
                Publishing Analytics
              </NavDropdown.Item>
            </NavDropdown>

            {/* <NavDropdown
              title={
                <span className="nav-link-custom">
                  <i className="bi bi-code-slash me-1"></i>Developers
                </span>
              }
              id="developers-dropdown"
            >
              <NavDropdown.Item href="https://geometric-bay-452700-j9-nutrad.apigee.io/">
                Developer Portal
              </NavDropdown.Item>
            </NavDropdown> */}

            <NavDropdown
              title={
                <span className="nav-link-custom">
                  <i className="bi bi-question-circle me-1"></i>Help
                </span>
              }
              id="help-dropdown"
            >
              <NavDropdown.Item as={Link} to="/tutorials">
                <i className="bi bi-play-circle me-2"></i>Video Tutorials
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/support">
                <i className="bi bi-headset me-2"></i>Support
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
          
          {isLoggedIn && (
            <Nav className="ms-auto">
              <div className="d-flex align-items-center">
                {user?.userFound?.isAdmin && (
                  <Link
                    to="/admin"
                    className="btn btn-outline-primary btn-sm me-3"
                  >
                    <i className="bi bi-speedometer2 me-1"></i>
                    Admin
                  </Link>
                )}
                <Link
                  to="/customer-profile"
                  className="btn btn-outline-secondary btn-sm me-2"
                >
                  <i className="bi bi-person me-1"></i>
                  Profile
                </Link>
                <button 
                  onClick={logoutHandler}
                  className="btn btn-outline-danger btn-sm"
                >
                  <i className="bi bi-box-arrow-right me-1"></i>
                  Logout
                </button>
              </div>
            </Nav>
          )}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
